<template>
	<BaseWebshopCart v-slot="{counter, cartUrl}">
		<div class="ww cart" @mouseover="cartPreview = true" @mouseleave="cartPreview = false" :class="{'counter': counter, 'active': counter && cartPreview}">
			<NuxtLink :to="cartUrl" class="ww-items">
				<div class="ww-cart-label">
					<ClientOnly>
						<span class="ww-counter">
							<span class="value total-items cart_info_item_count total_items">{{counter}}</span>
						</span>
					</ClientOnly>
					<BaseCmsLabel code="shopping_cart" />
				</div>
			</NuxtLink>

			<ClientOnly>
				<LazyWebshopCartPreview v-if="counter && cartPreview && !tabletBreakpoint" mode="preview" />
			</ClientOnly>
		</div>
	</BaseWebshopCart>
</template>

<script setup>
	const cartPreview = ref(false);
	const {tabletBreakpoint} = inject('rwd');
</script>

<style lang="less" scoped>
	.ww{
		position: relative;
		&.counter .ww-cart-label:after{display: block;}
		@media (max-width: @tp){position: unset;}
	}
	.ww-items{
		width: 50px; height: 50px; transition: var(--transition); display: flex; align-items: center; justify-content: center; border-right: 1px solid rgba(255,255,255,0.2); position: relative;
		@media (max-width: @l){width: 44px; height: 44px;}
		@media (max-width: @tp){width: 30px; height: 56px; right: 12px; position: absolute; top: 0; border: unset;}
	} 
	.ww-cart-label{
		position: relative; display: flex; align-items: center; justify-content: center; width: 50px; height: 50px; font-size: 0;
		&:before{.icon-cart; font: 21px/21px var(--fonti); left: 0; position: absolute; display: block; top: 0; color: white; width: 50px; height: 50px; display: flex; align-items: center; justify-content: center;}
		@media (max-width: @l){
			width: 44px; height: 44px;
			&:before{font: 18px/18px var(--fonti); width: 44px; height: 44px;}
		}
		@media (max-width: @tp){
			width: 30px; height: 56px;
			&:before{font: 22px/22px var(--fonti); width: 30px; height: 56px;}
		}
		.ww-counter{
			position: absolute; display: block; text-align: center; color: white; top: 4px; font-weight: bold; right: 7px; font-size: 14px; line-height: 16px;
			@media (max-width: @l){top: 3px; right: 5px; font-size: 13px; line-height: 16px;}
			@media (max-width: @tp){top: 6px; right: -3px; font-size: 11px; line-height: 14px;}
			@media (max-width: @m){top: 7px; right: -2px;}
		}
	}
</style>
